import React, { useCallback, useEffect } from 'react';
import { SAMLLoginURL, SAMLAuth } from '../../data/auth-service';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import { StyledEngineProvider } from '@mui/styled-engine-sc';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import Themes from '../../data/themes';
import Box from '@mui/material/Box';
import CSSBaseline from '@mui/material/CssBaseline';
import { makeStyles } from '@mui/styles';
import { get as _get } from 'lodash';
import { useNavigate } from 'react-router-dom';
import useGoHome from './home';

const useStyles = makeStyles(theme => ({
    background: {
        background: _get(theme, 'palette.background.default', '#F7F7F7'),
    },
    available: {
        marginLeft: 330,
    },
    redirect: {
        display: 'flex',
        '& > * + *': {
            marginLeft: useTheme().spacing(2),
        },
    },
    error: {
        color: _get(theme, 'palette.error.main', '#C40030'),
    }
}));

const SAMLLogin = () => {
    useEffect(() => {
        // Step 1
        console.log('SAMLLogin', SAMLLoginURL);
        window.location.replace(SAMLLoginURL);
    }, []);
    return (
        <Grid container direction="column" justifyContent="center" alignItems="center">
            <div>Connecting to Single Sign-on Server</div>
            <CircularProgress />
        </Grid>
    );
};

const SAMLLoginCallback = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const goHome = useGoHome();

    const handleLoginError = useCallback(err => {
        console.log('SAMLLoginCallback login error', err);
        const msg = (err || '').includes('user update')
            ? `This user may already be associated with an OpenText™ NDR account.
                <br/>Please use OpenText™ NDR Login or contact your Administrator.`
            : 'Login failed, please try again';
        navigate('/signin', { replace: true, state: { error: msg } });
    }, [navigate]);

    const handleLoginSuccess = useCallback(res => {
        console.log('SAMLLoginCallback login success', res.user);
        goHome(res.user);
    }, [goHome]);

    const fetchSession = useCallback(() => {
        console.log('SAMLLoginCallback fetchSession');
        SAMLAuth.GetSession().then(res => {
            // step 3
            SAMLAuth.Login().then(
                handleLoginSuccess,
                handleLoginError
            ).catch(handleLoginError);
        }, () => {
            navigate('/signin', {
                replace: true,
                state: { error: 'Single Sign-On may not be available' },
            });
        });
    }, [handleLoginSuccess, handleLoginError, navigate]);

    useEffect(() => {
        fetchSession();
    }, [fetchSession]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={Themes.DarkTheme}>
                <Box maxWidth="lg" height="100%" className={classes.background} color="text.primary">
                    <CSSBaseline />
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Box textAlign="center" mt={30} mb={5}>
                            <img aria-label="logo" src="/images/logo-new.png" />
                        </Box>
                    </Grid>
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                        <div>Processing response</div>
                        <CircularProgress />
                    </Grid>
                </Box>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export { SAMLLogin, SAMLLoginCallback };
